export const GET_STATO_RICHIESTE_DATA_AND_LOADING =
  "GET_STATO_RICHIESTE_DATA_AND_LOADING";
export const GET_STATO_RICHIESTE_DETAILS = "GET_STATO_RICHIESTE_DETAILS";
export const EXPORT_STATO_RICHIESTE = "EXPORT_STATO_RICHIESTE";
